<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex flex-col gap-6 bg-gray-50 p-6">
    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Ustawienia walidacji</h5>

      <div class="mt-6 grid gap-x-6">
        <app-form-control
          label="Lista zablokowanych numerów NIP"
          hint="Wprowadź jeden numer NIP w osobnej linii.">
          <textarea
            [formControl]="form.controls.nipBlackList"
            appPrimengTextarea
            pTextarea
            rows="10"></textarea>
        </app-form-control>
      </div>
    </section>

    <div class="mt-auto flex justify-end">
      <p-button
        appPrimengButton
        label="Zapisz"
        severity="primary"
        type="submit" />
    </div>
  </div>
</form>
